module.exports = __webpack_public_path__ + "img/loading-plane.ae8ad500.gif";